import { Component, Input } from '@angular/core';
import { Chip } from './va-chip';

@Component({
  template: `
    <mat-chip-listbox [selectable]="false">
      <mat-chip-option *ngIf="config.text" selected="true" color="{{ config.color }}">
        {{ config.text }}
      </mat-chip-option>
    </mat-chip-listbox>
  `,
})
export class VaChipComponent {
  @Input() config: Chip;
}
